import { AfterViewInit, Component, inject, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone'
import { TranslateService } from '@ngx-translate/core'
import { filter } from 'rxjs'
import { UiDialogHostComponent } from './shared/components/ui-dialog-host/ui-dialog-host.component'

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [IonRouterOutlet, IonApp, RouterOutlet, UiDialogHostComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit {
	private translate = inject(TranslateService)
	private router = inject(Router)
	private titleService = inject(Title)

	constructor() {
		console.log('|30-09-2026 / PGC Onetoro v2.0.9|')

		this.translate.setDefaultLang('es')
		this.translate.use(this.translate.getBrowserLang() || this.translate.getDefaultLang())
	}

	ngOnInit(): void {
		this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(data => {
			const event = data as NavigationEnd
			const url = event.urlAfterRedirects.split('/')[1]
			const translatedRoute = this.translate.instant(url.toUpperCase())
			this.titleService.setTitle(`PGC - ${translatedRoute}`)
		})
	}

	ngAfterViewInit(): void {
		// Obtener el valor del nonce generado dinámicamente
		const metaNonce = document.querySelector('meta[name="csp-nonce"]')
		const nonce = metaNonce?.getAttribute('content')

		if (nonce) {
			// Aplicar el nonce a todos los elementos <style> generados dinámicamente
			const styleSheets = document.querySelectorAll('style')
			styleSheets.forEach((style: HTMLElement) => {
				if (!style.hasAttribute('nonce')) {
					style.setAttribute('nonce', nonce)
				}
			})
		}
	}
}
